import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';
import { billingKeys } from '@/services/query-keys/billing-keys';
import type { ReRatePayload } from '@/services/trades/rerate-mapper';

/**
 * LR-528: re-rate an ACTIVE (or backdated MATURED) position via
 * POST /positions/{id}/re-rate/. Invalidates the whole positions cache
 * (tradesKeys.all → detail + list + activity all refetch, since they share the
 * ['positions'] prefix) plus the accruals prefix — a backdated re-rate recomputes
 * the AccrualEntry window (LR-527), so the analytics / billing figures must refetch.
 */
export const useReRate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: ReRatePayload }) =>
      tradesService.reRate(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
      queryClient.invalidateQueries({ queryKey: billingKeys.accruals() });
    },
  });
};
